import React, { useEffect, useRef } from 'react';
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom';

import About from './pages/policies/about';
import { Box } from '@mui/material';
import CVPolicies from './pages/policies/cvPolicies';
import Champs from './pages/champs';
import Contests from './pages/contests';
import FAQ from './pages/policies/faq';
import Footer from './components/footer';
import Header from './components/header';
import Home from './pages/home';
import Post from './pages/post';
import Register from './pages/register';
import ScrollToTop from './components/scroll-to-top';
import Terms from './pages/policies/termsAndCondition';
import UserBooks from './pages/user-profile/book';
import UserContests from './pages/user-profile/contest';
import UserProfile from './pages/user-profile/index';
import UserQuests from './pages/user-profile/quest';
import UserWork from './pages/user-profile/work';
import Achivements from './pages/user-profile/achievement';
import Quests from './pages/quests/index';
import AllClubs from './pages/home/all-clubs';
import ClubDetail from './pages/home/club-detail';
import QuestDetail from './pages/quests/questDetail';
import DOC from './pages/policies/doc';
import COPPAPolicices from './pages/policies/coppa';
import RemoveAccount from './pages/policies/removeAccount';
import ContestDetail from './pages/contests/contestDetail';
import Analytics from './analytics/anlaytics';
import UserClubs from './pages/user-profile/clubs';
import Prizes from './pages/Prizes';
import PrizesDetail from './pages/Prizes/prizesDetail';
import ClanDetail from './pages/clan/clan-detail';

export default function App() {
  const downloadAppRef = useRef<HTMLDivElement>(null);

  const scrollToAppDownload = () => {
    if (downloadAppRef.current) {
      downloadAppRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        padding: 0,
        margin: 0
      }}>
      <Router>
        <Analytics />
        <ScrollToTop />
        {/* This component updates the body class dynamically */}
        <Header scrollToAppDownload={scrollToAppDownload} />
        <Box component="main" sx={{ flexGrow: 1, my: 2, width: '100vw', px: 0 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/champs" element={<Champs />} />
            <Route path="/contests" element={<Contests />} />
            <Route path="/register" element={<Register />} />
            <Route path="/user/:handle" element={<UserProfile />} />
            <Route path="/work/:postId" element={<Post />} />
            <Route path="/user/:handle/works" element={<UserWork />} />
            <Route path="/user/:handle/books" element={<UserBooks />} />
            <Route path="user/:handle/contests" element={<UserContests />} />
            <Route path="user/:handle/quests" element={<UserQuests />} />
            <Route path="user/:handle/clubs" element={<UserClubs />} />
            <Route path="user/:handle/achievements" element={<Achivements />} />
            <Route path="/about" element={<About />} />
            <Route path="/terms&conditions" element={<Terms />} />
            <Route path="/kids-terms" element={<Terms />} />
            <Route path="/cv-policies" element={<CVPolicies />} />
            <Route path="/coppa-policies" element={<COPPAPolicices />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/doc" element={<DOC />} />
            <Route path="/quests" element={<Quests />} />
            <Route path="/clubs" element={<AllClubs />} />
            <Route path="/club/:clubId" element={<ClubDetail />} />
            <Route path="/quest" element={<QuestDetail />} />
            <Route path="/quest/:questID" element={<QuestDetail />} />
            <Route path="/removeAccount" element={<RemoveAccount />} />
            <Route path="/contest/:contestId" element={<ContestDetail />} />
            <Route path="/prizes" element={<Prizes />} />
            <Route path="/prizes/:id" element={<PrizesDetail />} />
            <Route path="/clan/:clanid" element={<ClanDetail />} />
          </Routes>
        </Box>
        <Footer ref={downloadAppRef} />
      </Router>
    </Box>
  );
}
